import Lottie from 'lottie-react';
import TodoList from '../jsons/to-do-list.json';


const LottieTodo = props => {
  return <Lottie animationData={TodoList} loop={false} {...props} />;
};

export default LottieTodo;
